import { setupBugsink, SetupBugsinkI } from '@common/utils/bugsink.js';
import packageJson from '@root/package.json' with { type: 'json' };
import { config } from '@src/config/index.js';

setupBugsink({
  dsns: config.bugsinkDsns,
  version: packageJson.version,
} as SetupBugsinkI);

import '@src/components/TefComs4p.js'; // eslint-disable-line -- import only after bugsink init
